import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateLoader, TranslateModule, TranslatePipe, TranslateService } from '@ngx-translate/core';
import { TRANSLATE_HTTP_LOADER_CONFIG, TranslateHttpLoader } from '@ngx-translate/http-loader';

import { HttpJsonUtilities } from './http/http-json-utilities.service';
import { ActivityService } from './activity/activity.service';
import { HttpConfigService } from './http/http-config.service';
import { AuthInterceptor } from './services/auth.interceptor';

import {
  AccountClient,
  API_BASE_URL,
  ClientClient,
  DashboardClient,
  ParkerClient,
  ParkerCompanyClient,
  ThirdPartyUserClientZoneAssignmentClient,
  ParkingRangerClientZoneAssignmentClient,
  UserAccountClient,
  UserControlPlateClient,
  ZoneClient,
  ZoneDeviceClient,
  ParkingProcessInfoClient
} from './models/models.swagger.generated';

import { AppErrorMessagesService } from './services/app-error-messages.service';
import { EnumTranslationService } from './services/enum-translation.service';

import { environment } from '../../environments/environment';
import { LoginProxy } from './http/login-proxy.service';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import {
  ColumnChooserService,
  CommandColumnService,
  EditService,
  FilterService,
  PageService, ResizeService,
  SearchService,
  SortService,
  ToolbarService,
} from '@syncfusion/ej2-angular-grids';
import { ClientService } from './services/client/client.service';
import { LightboxModule } from 'ngx-lightbox';
import { TranslationLoaderResolver } from './resolver/translation-loader.resolver';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { ModalHelperService } from './shared/modal-helper';
import { EnumFilterService } from './services/enum-filter.service';

// AoT requires an exported function for factories
export function HttpLoaderFactory() {
  return new TranslateHttpLoader();
}

export const tokenGetter = () =>  localStorage.getItem(environment.localStorageToken);

@NgModule({ bootstrap: [],
    exports: [
        RouterModule,
        ReactiveFormsModule,
        TranslateModule,
        //BrowserAnimationsModule, // WARNING: do not use browser animations module here, it will cause errors with syncfusion V25+
        FontAwesomeModule,
        NgIdleKeepaliveModule,
    ], imports: [
        RouterModule,
        ReactiveFormsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
            },
        }),
        //BrowserAnimationsModule, // WARNING: do not use browser animations module here, it will cause errors with syncfusion V25+
        FontAwesomeModule,
        FormsModule,
        NgIdleKeepaliveModule.forRoot(),
        LightboxModule,
        ZXingScannerModule],
        providers: [
        { provide: TRANSLATE_HTTP_LOADER_CONFIG, useValue: { prefix: './assets/i18n/', suffix: '.json' } },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: API_BASE_URL, useValue: environment.apiServerUrl },
        HttpClient,
        HttpJsonUtilities,
        HttpConfigService,
        TranslateService,
        TranslatePipe,
        ActivityService,
        LoginProxy,
        AppErrorMessagesService,
        EnumTranslationService,
        ModalHelperService,
        ClientService,
        TranslationLoaderResolver,
        EnumFilterService,
        /* swagger clients */
        AccountClient,
        ClientClient,
        DashboardClient,
        ParkerClient,
        ParkerCompanyClient,
        UserControlPlateClient,
        UserAccountClient,
        ZoneClient,
        ZoneDeviceClient,
        ThirdPartyUserClientZoneAssignmentClient,
        ParkingRangerClientZoneAssignmentClient,
        ParkingProcessInfoClient,
        /* Syncfusion services */
        PageService,
        ToolbarService,
        ColumnChooserService,
        FilterService,
        SortService,
        EditService,
        CommandColumnService,
        SearchService,
        ResizeService,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class BaseModule {
}
